import { Button } from 'antd';
import { isEmpty, join, map } from 'lodash';
import React from 'react';
import { connect, useSelector } from 'react-redux';
import { ADP } from '../../../common/analytics/sourceTypes';
import { heroImageConfig } from '../../../common/helpers/sharpie/sharpie';
import { MILLION_BATH } from '../../../common/helpers/constants';
import { handleImageUrl } from '../../../common/helpers/sharpie/imageUrlHelper';
import { getProjectPagePath } from '../../../common/helpers/routing/urlGenerator';
import contentResource from '../../../locales/th/content.json';
import LazyImage from '../../lazyImage/LazyImage';
import {
  ImageOverlay,
  ProjectInfoAttribute,
  ProjectInfoCaption,
  ProjectInfoHeroImage,
  ProjectInformationWrapper,
  ProjectInfoTitle,
} from './RelatedProjectInformation.style';
import { trackProjectClick } from '../../../common/analytics/analyticsTracker';
import { WholeState } from '../../../store/common/type';
import { AnalyticsProject } from '../../../common/analytics/interfaces/analyticsProject';
import { SharpieImageConfig } from '../../../common/helpers/sharpie/useSharpie';

interface HeroImageData {
  url: string;
  title: string;
}
interface RelatedProjectInformationProps {
  heroImageData: HeroImageData;
  deviceType: string;
  project: AnalyticsProject;
  lazyLoad: boolean;
  projectNetProjectHref?: string;
}

const RelatedProjectInformation: React.FC<RelatedProjectInformationProps> = ({
  heroImageData,
  deviceType,
  project,
  lazyLoad,
  projectNetProjectHref,
}) => {
  const {
    name,
    link,
    location: { zone },
    priceTypes: { starting_price },
  } = project;
  const imageInfo = heroImageConfig[deviceType as keyof SharpieImageConfig];
  const isNextGenSupported = useSelector((state: WholeState) =>
    state.common !== undefined ? state.common.isNextGenSupported : false,
  );
  const userInfo = useSelector((state: WholeState) =>
    state.common !== undefined ? state.common.user : {},
  );
  const sharpieImgUri = handleImageUrl(
    heroImageData.url,
    imageInfo.width,
    imageInfo.height,
    isNextGenSupported,
  );
  const hrefLink = projectNetProjectHref ?? getProjectPagePath(link);
  const projectArea = map(zone, (item) => item.label);
  const price = !isEmpty(starting_price)
    ? starting_price + ' ' + MILLION_BATH
    : '-';
  const area = !isEmpty(projectArea) ? join(projectArea, ', ') : '-';

  return (
    <ProjectInformationWrapper data-test={'projet-information'}>
      <ProjectInfoHeroImage>
        <ImageOverlay />
        <LazyImage
          src={sharpieImgUri}
          alt={heroImageData.title}
          lazyLoad={lazyLoad}
        />
        <ProjectInfoCaption>
          <ProjectInfoTitle>
            <p>{name}</p>
          </ProjectInfoTitle>
          <a
            href={hrefLink}
            onClick={() => trackProjectClick(userInfo, project, ADP.PAGE)}
          >
            <Button className="view-project-btn">
              {contentResource.relatedProjectInfo.viewProject}
            </Button>
          </a>
        </ProjectInfoCaption>
      </ProjectInfoHeroImage>
      <ProjectInfoAttribute>
        <div className="attribute-detail location-info">
          <span>{contentResource.relatedProjectInfo.locationZone}</span>
          <p>{area}</p>
        </div>
        <div className="attribute-detail price-info">
          <span>{contentResource.relatedProjectInfo.startingPrice}</span>
          <p>{price}</p>
        </div>
      </ProjectInfoAttribute>
    </ProjectInformationWrapper>
  );
};

const mapStateToProps = (state: WholeState) => {
  return {
    deviceType:
      state.common !== undefined ? state.common.deviceType : 'desktop',
  };
};

export default connect(mapStateToProps)(RelatedProjectInformation);
